import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Button } from 'react-bootstrap';
import { buyShares, sellShares } from '../store/slices/accountSlice';

function Trading() {
  const dispatch = useDispatch();
  const [symbol, setSymbol] = useState('');
  const [quantity, setQuantity] = useState('');
  const handleBuy = () => {
    dispatch(buyShares({ symbol, quantity: Number(quantity) }));
    clearForm();
  };

  const handleSell = () => {
    dispatch(sellShares({ symbol, quantity: Number(quantity) }));
    clearForm();
  };

  const clearForm = () => {
    setSymbol('');
    setQuantity('');
  };

  return (
    <div>
      <h2>Trading</h2>
      <Form>
        <Form.Group controlId='formSymbol'>
          <Form.Label>Stock Symbol</Form.Label>
          <Form.Control
            type='text'
            placeholder='Enter symbol (e.g., AAPL)'
            value={symbol}
            onChange={(e) => setSymbol(e.target.value)}
          />
        </Form.Group>
        <Form.Group controlId='formQuantity'>
          <Form.Label>Quantity</Form.Label>
          <Form.Control
            type='number'
            placeholder='Enter quantity'
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
          />
        </Form.Group>
        <Button variant='success' onClick={handleBuy} className='mr-2'>Buy</Button>
        <Button variant='danger' onClick={handleSell}>Sell</Button>
      </Form>
    </div>
  );
}

export default Trading;
